import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import zhCN from './locales/zh-CN.json'
import en from './locales/en.json'
import ja from './locales/ja.json'
import ko from './locales/ko.json'
import es from './locales/es.json'

const SUPPORTED = ['zh-CN', 'en', 'ja', 'ko', 'es'] as const
export type SupportedLocale = (typeof SUPPORTED)[number]

const STORAGE_KEY = 'dogdisk_locale'

function detectLocale(): SupportedLocale {
  if (typeof localStorage !== 'undefined') {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved && (SUPPORTED as readonly string[]).includes(saved)) {
      return saved as SupportedLocale
    }
  }
  if (typeof navigator !== 'undefined') {
    const lang = navigator.language
    const match = SUPPORTED.find((l) => lang.startsWith(l) || lang.startsWith(l.slice(0, 2)))
    if (match) return match
  }
  return 'zh-CN'
}

void i18n.use(initReactI18next).init({
  resources: {
    'zh-CN': { translation: zhCN },
    en: { translation: en },
    ja: { translation: ja },
    ko: { translation: ko },
    es: { translation: es },
  },
  lng: detectLocale(),
  fallbackLng: 'zh-CN',
  interpolation: { escapeValue: false },
  returnNull: false,
})

export function setLocale(locale: SupportedLocale): void {
  void i18n.changeLanguage(locale)
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, locale)
  }
}

export { i18n, SUPPORTED }
